const dateMask = "99/99/9999"
const cpfCnpjInputProps = { inputMode: "numeric", pattern: "[0-9]*", maxLength: 16 }

export const ofertaFields = [
    { key: "distribuicao", label: "Distribuição", md: 4, defaultValue: "ICVM160" },
    { key: "linkSre", label: "Link SRE", md: 4, defaultValue: null },
    { key: "situacaoDistribuicao", label: "Situação Distribuição", md: 4, defaultValue: null },
    { key: "situacaoOferta", label: "Situação Oferta", md: 4, defaultValue: null },
    { key: "tipoRito", label: "Tipo Rito", md: 4, defaultValue: null },
    { key: "bookbuilding", label: "Bookbuilding", md: 4, defaultValue: null },
    { key: "regimeDistribuicao", label: "Regime Distribuição", md: 4, defaultValue: null },
]

export const ofertaRadios = [
    {
        key: "tipoMercado",
        label: "Tipo mercado",
        md: 4,
        type: "radio",
        direction: "row",
        columns: 2,
        itemsPerColumn: 2,
        defaultValue: "primaria",
        items: [
            { value: "primaria", label: "Primária" },
            { value: "secundaria", label: "Secundária" },
        ],
        spacing: { mt: 1.25, mb: 0 },
        horizontalSpacing: { xlg: 0, lg: 8, md: 8 },
    },
]

export const publicoAlvoRadios = [
    {
        key: "investidorGeralInicial",
        label: "Investidor geral inicial",
        type: "radio",
        md: 4,
        defaultValue: null,
        direction: "row",
        columns: 2,
        itemsPerColumn: 2,
        spacing: { mt: 0, mb: 0 },
        horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
    },
    {
        key: "investidorQualificadoInicial",
        label: "Investidor qualificado inicial",
        type: "radio",
        md: 4,
        defaultValue: null,
        direction: "row",
        columns: 2,
        itemsPerColumn: 2,
        spacing: { mt: 0, mb: 0 },
        horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
    },
    {
        key: "investidorProfissionalInicial",
        label: "Investidor profissional inicial",
        type: "radio",
        md: 4,
        defaultValue: null,
        direction: "row",
        columns: 2,
        itemsPerColumn: 2,
        spacing: { mt: 0, mb: 0 },
        horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
    },
    {
        key: "investidorGeralFinal",
        label: "Investidor geral final",
        type: "radio",
        md: 4,
        defaultValue: null,
        direction: "row",
        columns: 2,
        itemsPerColumn: 2,
        spacing: { mt: 0, mb: 0 },
        horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
    },
    {
        key: "investidorQualificadoFinal",
        label: "Investidor qualificado final",
        type: "radio",
        md: 4,
        defaultValue: null,
        direction: "row",
        columns: 2,
        itemsPerColumn: 2,
        spacing: { mt: 0, mb: 0 },
        horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
    },
    {
        key: "investidorProfissionalFinal",
        label: "Investidor profissional final",
        type: "radio",
        md: 4,
        defaultValue: null,
        direction: "row",
        columns: 2,
        itemsPerColumn: 2,
        spacing: { mt: 0, mb: 0 },
        horizontalSpacing: { xlg: -6, lg: 0, md: 4 },
    },
]

export const publicoDatas = [
    { key: "dataRequerimento", label: "Data Requerimento", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataRegistro", label: "Data Registro", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataInicioOferta", label: "Data Início Oferta", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataEncerramentoMax", label: "Encerramento Oferta Máximo", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataEncerramentoEfetivo", label: "Encerramento Oferta Efetivo", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataInicioReserva", label: "Data Início Reserva", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataEncerramentoReserva", label: "Data Encerramento Reserva", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataBookbuilding", label: "Data Bookbuilding", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", breakAfter: true, defaultValue: null },
    { key: "dataLockupIGparaIG", label: "Data Lockup IG para IG", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIGparaIQ", label: "Data Lockup IG para IQ", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIGparaIP", label: "Data Lockup IG para IP", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIQparaIG", label: "Data Lockup IQ para IG", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIQparaIQ", label: "Data Lockup IQ para IQ", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIQparaIP", label: "Data Lockup IQ para IP", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIPparaIG", label: "Data Lockup IP para IG", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIPparaIQ", label: "Data Lockup IP para IQ", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
    { key: "dataLockupIPparaIP", label: "Data Lockup IP para IP", md: 4, mask: dateMask, maskType: "date", minDate: "01/01/1900", defaultValue: null },
]

export const coordenadoresFields = [
    { key: "coordLider", label: "CPF CNPJ Coordenador Líder", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
    { key: "coord1", label: "CPF CNPJ Coordenador 1", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
    { key: "coord2", label: "CPF CNPJ Coordenador 2", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
    { key: "coord3", label: "CPF CNPJ Coordenador 3", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
    { key: "coord4", label: "CPF CNPJ Coordenador 4", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
    { key: "coord5", label: "CPF CNPJ Coordenador 5", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
    { key: "coord6", label: "CPF CNPJ Coordenador 6", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
    { key: "coord7", label: "CPF CNPJ Coordenador 7", md: 6, type: "autoComplete", autoCompleteSource: "empresas", inputProps: cpfCnpjInputProps, maskType: "cpfCnpj", defaultValue: null },
]
